import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const PlayIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <g clipPath="url(#clip0_10431_50833)">
            <path
               d="M4.625 21.4043L20.375 11.9774L4.625 2.55052V21.4043ZM3.33984 0.306276C4.17109 -0.149001 5.18281 -0.127576 5.99219 0.354482L21.7422 9.78139C22.5242 10.2474 23 11.0776 23 11.9774C23 12.8773 22.5242 13.7021 21.7422 14.1735L5.99219 23.6004C5.18281 24.0878 4.16563 24.1039 3.33984 23.6486C2.51406 23.1933 2 22.3363 2 21.4043V2.55052C2 1.61854 2.51406 0.761552 3.33984 0.306276Z"
               fill="currentColor"
            />
         </g>
         <defs>
            <clipPath id="clip0_10431_50833">
               <rect
                  width="24"
                  height="24"
                  fill="white"
               />
            </clipPath>
         </defs>
      </svg>
   )
}

export default PlayIcon
